var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"mt-n50",attrs:{"src":require("@/assets/images/logo/logo.png"),"alt":"logo","height":"40px"}})}
var staticRenderFns = []

export { render, staticRenderFns }